import React from 'react';

import LoadingIndicator from '@dashboard/components/loading/LoadingIndicator';
import ButtonLink from '@dashboard/components/mui-atoms/ButtonLink';
import { usePlatformsQuery } from '@dashboard/generated/wp/authentication';
import plusIconSrc from '@dashboard/images/waypoint-plus.png';
import { AddOutlined } from '@mui/icons-material';
import { Box, Grid, Stack, Typography } from '@mui/material';

import FoundersLetter from './FoundersLetter';
import PlatformTileLink from './PlatformTileLink';
import TileLink from './TileLink';

export default function PlatformsListPage() {
  const { data } = usePlatformsQuery({ fetchPolicy: 'network-only' });
  if (!data?.Platforms) {
    return (
      <Box my={5}>
        <LoadingIndicator />
      </Box>
    );
  }

  const { count, nodes } = data.Platforms;
  if (count === 0) {
    return <FoundersLetter />;
  }

  const renderSecondaryNewButton = () => {
    if (count <= 4) {
      return null;
    }
    return (
      <ButtonLink
        href="/organizations/new"
        size="small"
        variant="contained"
        color="primary"
        startIcon={<AddOutlined />}
      >
        New
      </ButtonLink>
    );
  };

  return (
    <>
      <Stack direction="row" spacing={2} justifyContent="space-between" sx={{ my: 2 }}>
        <Typography variant="h4">Workspaces</Typography>
        {renderSecondaryNewButton()}
      </Stack>
      <Grid container spacing={{ xs: 2, md: 3 }} mb={4}>
        {nodes.map((platform, i) => (
          <PlatformTileLink key={i} platform={platform} />
        ))}
        <TileLink href="/organizations/new">
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', pb: 2 }}>
            <Box component="img" src={plusIconSrc} alt="Plus icon" sx={{ maxWidth: 48, mt: 1 }} />
          </Box>
        </TileLink>
      </Grid>
    </>
  );
}
